import { UserService } from './user.service';

export function initializeUser(userService: UserService): () => Promise<void> {
  return () => userService.loadAndStoreUserInfo();
}
